import { Link } from "react-router-dom";
function Rules() {
  return (
    <div className="">
      <div className="bgImg fixed"></div>
      <div className="App">
        <div className="h-38"></div>
        <header className="bg-zinc-900/90 drop-shadow-lg text-zinc-200 top-0 z-10 w-[80%] pb-8 ml-[10%] text rounded-xl">
          <div className="grid lg:grid-cols-3">
            <Link className="link mt-4" to="/application">
              <button
                type="submit"
                className="themeBg hover:bg-gray-700 mx-[5%] text text-xl font-semibold text-zinc-200 py-1.5 px-3 rounded-3xl flex"
              >
                <span className="mr-2 ">Back</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
                    />
                  </svg>
                </span>
              </button>
            </Link>
            <div className="text-3xl pt-4 font-semibold">Server Rules</div>
          </div>

          <div className="mt-4 text-md">
            <div className="lg:mx-[10%] mx-[5%]">
              Rules (these apply to both the Discord and Minecraft server)
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">1. Use English.</div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              2. Respect everyone regardless of their race, nationality, gender,
              etc.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              3. PVP and grief is allowed, so make sure to claim your territory
              with the claims mod if that is something you don't want to
              participate in.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              4. Keep this community a safe, welcoming, and supportive place.
              Report rule-breaking behavior to staff immediately instead of
              intervening or fighting.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              5. Use Discord channels for their intended purpose. For example,
              don't ask if someone wants to buy an Elytra on the media channel.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              6. Swearing is allowed, but keep it civilized ( Mainly just don't
              want you guys calling each other names ).
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-2">
              7. All rules are subject to common sense. For example, don't
              grief, kill, spam, create lag machines, dupe items, or dox others.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-6">
              Consequences: 1st warning, verbal warning. 2nd warning, 1 day
              timeout. 3rd warning, Ban.
            </div>
            <div className="lg:mx-[10%] mx-[5%]">
              Breaking serious rules may result in a ban on the first offense.
            </div>
            <div className="lg:mx-[10%] mx-[5%] mt-4">
              To ensure the long-term activity and development of the server,
              players will be blacklisted for the remainder of the season if
              they violate this contract. You must actively play on the server
              for the length of the season. Inactivity means not actively
              playing on the server for more than a week. Understand that this
              is a time commitment and that if you cannot play for a certain
              amount of time. That being said if you have a event or some reason
              that you cannot play for this amount of time, tell Owen ahead of
              time and give a valid reason.
            </div>
          </div>
          <div> </div>
        </header>
        <div className="h-34"></div>
      </div>
    </div>
  );
}
export default Rules;
